export default __webpack_public_path__ + "static/media/toyota.2b2caef8.svg";